var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drive-items" },
    [
      _vm._l(_vm.$store.state.drives, function(drive) {
        return _c(
          "div",
          {
            key: drive.id,
            staticClass: "drive-item",
            class:
              _vm.$store.state.curDriveId == drive.id
                ? _vm.$route.path == "/mc_project/lite_file"
                  ? "selected"
                  : ""
                : "",
            on: {
              click: function($event) {
                return _vm.openDrive(drive.id)
              }
            }
          },
          [
            _c("div", { class: "drive-item-icon drive-icon-" + drive.type }),
            _vm._v(" "),
            _c("span", { staticClass: "drive-item-name" }, [
              _vm._v(_vm._s(drive.name))
            ]),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "light",
                  placement: "bottom",
                  "visible-arrow": false,
                  "popper-class": "my-tooltip"
                },
                model: {
                  value: drive.showMore,
                  callback: function($$v) {
                    _vm.$set(drive, "showMore", $$v)
                  },
                  expression: "drive.showMore"
                }
              },
              [
                _c("template", { slot: "content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "drive_more_item drive_rename",
                      on: {
                        click: function($event) {
                          return _vm.renameDrivePopup(drive)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.rename")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "drive_more_item drive_edit",
                      on: {
                        click: function($event) {
                          return _vm.editDrivePopup(drive)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.leftBanner.edit")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "drive_more_item drive_delete",
                      on: {
                        click: function($event) {
                          return _vm.deleteDrivePopup(drive)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.leftBanner.remove")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "drive_more_item drive_properties",
                      on: {
                        click: function($event) {
                          return _vm.infoDrive(drive)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.properties")))]
                  )
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-more",
                  on: {
                    click: function($event) {
                      return _vm.showMore(drive)
                    }
                  }
                })
              ],
              2
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.driveInfo.show,
              expression: "driveInfo.show"
            }
          ],
          staticClass: "lite_popup drive_info",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.blankClick()
            }
          }
        },
        [
          _c("div", { staticClass: "lite_popup_box" }, [
            _c("div", { staticClass: "lite_popup_title" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("language.common.properties")))
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    _vm.driveInfo.show = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lite_popup_content" },
              [
                _c(
                  "el-form",
                  { attrs: { "label-width": "100px" } },
                  [
                    _vm.thisDrive
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.cloudName"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(_vm._s(_vm.thisDrive.name))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.thisDrive
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.cloudType"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(_vm._s(_vm.thisDrive.type))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.thisDrive
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.addedTime"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(
                                _vm._s(_vm.formatDate(_vm.thisDrive.ctime))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.name
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(_vm._s(_vm.driveInfo.name))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.email
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.email") } },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(_vm._s(_vm.driveInfo.email))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.used
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.usedSpace"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(
                                _vm._s(_vm.formatBytes(_vm.driveInfo.used))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.total
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.totalSpace"
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(
                                _vm._s(_vm.formatBytes(_vm.driveInfo.total))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.ftp.host
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.protocol"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.protocol))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.server"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.host))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.port"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.port))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.userName"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.username))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.passive"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.passive))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.encoding"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.encoding))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.path"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.ftp.path))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.sftp.host
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.server"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.sftp.host))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.port"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.sftp.port))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.userName"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.sftp.username))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.path"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.sftp.path))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.webdav.url
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.server"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.webdav.url))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "language.popup.addCloudPopup.userName"
                                  )
                                }
                              },
                              [
                                _c("div", { staticClass: "drive_info_text" }, [
                                  _vm._v(_vm._s(_vm.driveInfo.webdav.username))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.driveInfo.mediafire.email
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.email") } },
                          [
                            _c("div", { staticClass: "drive_info_text" }, [
                              _vm._v(_vm._s(_vm.driveInfo.mediafire.email))
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("liteInput", {
        ref: "inputPopup",
        attrs: { autoClose: false, data: _vm.input_popup_data },
        on: { ok: _vm.inputPopupOK },
        nativeOn: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.blankClick()
          }
        }
      }),
      _vm._v(" "),
      _c("liteConfirm", {
        ref: "confirmPopup",
        attrs: { data: _vm.confirm_popup_data },
        on: { ok: _vm.confirmPopupOK },
        nativeOn: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.blankClick()
          }
        }
      }),
      _vm._v(" "),
      _c("liteAddDrive", {
        attrs: { auth: _vm.auth },
        on: {
          submit: function($event) {
            return _vm.editCloud()
          }
        },
        nativeOn: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.blankClick()
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bac101fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bac101fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_drive.vue
// module id = null
// module chunks = 